export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/pianissimo-icon.svg?d137bed9a64f5d016235251e760c9298";